/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import './tools-ui.css'

const ITEM_H = 40

export default function WheelSelect({ id, label, value, options, onChange }) {
  const [open, setOpen] = useState(false)
  const [temp, setTemp] = useState(0)
  const colRef = useRef(null)
  const timer = useRef(0)
  const current = Math.max(0, options.findIndex((o) => o.value === value))

  const openDock = () => {
    setTemp(current)
    setOpen(true)
  }
  const close = () => setOpen(false)
  const confirm = () => {
    onChange(options[temp].value)
    setOpen(false)
  }

  useLayoutEffect(() => {
    if (open && colRef.current) colRef.current.scrollTop = current * ITEM_H
  }, [open, current])

  useEffect(() => {
    if (!open) return undefined
    const root = document.documentElement
    const prev = root.style.overflow
    root.style.overflow = 'hidden'
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => {
      root.style.overflow = prev
      document.removeEventListener('keydown', onKey)
      clearTimeout(timer.current)
    }
  }, [open])

  const onScroll = () => {
    clearTimeout(timer.current)
    timer.current = setTimeout(() => {
      const col = colRef.current
      if (!col) return
      const idx = Math.min(options.length - 1, Math.max(0, Math.round(col.scrollTop / ITEM_H)))
      setTemp(idx)
    }, 60)
  }

  const pick = (i) => {
    setTemp(i)
    if (colRef.current) colRef.current.scrollTo({ top: i * ITEM_H, behavior: 'smooth' })
  }

  return (
    <>
      <button type="button" id={id} className="tl-select tl-dockbtn" aria-haspopup="dialog" aria-expanded={open} onClick={openDock}>
        {options[current].label}
      </button>
      {open &&
        createPortal(
          <div className="tl-dock" onClick={(e) => e.target === e.currentTarget && close()}>
            <div className="tl-dock__sheet" role="dialog" aria-modal="true" aria-label={label} dir="rtl">
              <div className="tl-dock__head">
                <button type="button" className="tl-dock__ok" onClick={confirm}>تایید</button>
                <button type="button" className="tl-dock__x" aria-label="بستن" onClick={close}>✕</button>
              </div>
              <div className="tl-dock__body">
                <div className="tl-dock__wheel">
                  <div className="tl-dock__hl" />
                  <div className="tl-dock__col" ref={colRef} onScroll={onScroll}>
                    <div className="tl-dock__spacer" />
                    {options.map((o, i) => (
                      <div key={o.value} className={'tl-dock__item' + (i === temp ? ' is-sel' : '')} onClick={() => pick(i)}>
                        {o.label}
                      </div>
                    ))}
                    <div className="tl-dock__spacer" />
                  </div>
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  )
}
